<div class="email-container">
  <!-- Pre-Header -->
  <div class="pre-header">
    <div class="bg-gray"></div>
    <div class="view-browser" *ngIf="showViewInBrowser" (click)="onViewInBrowser()">View in browser →</div>
  </div>

  <!-- Menu With Button -->
  <div class="menu-section">
    <div class="logo-black">
      <img [src]="getLogoUrl()" alt="Logo" class="logo-img">
    </div>
  </div>

  <!-- Hero Image -->
  <div class="hero-image">
    <img [src]="getImageUrl()" alt="Hero Image" class="hero-img">
  </div>

  <!-- Header Content -->
  <div class="header-content">
    <div class="content-frame">
      <div class="title-section" [class.button-top]="emailData.buttonPosition === 'top'">
        <h1 class="main-title">{{ emailData.header || 'Email Header' }}</h1>
        <button 
        *ngIf="emailData.buttonPosition === 'top' && emailData.buttonText" 
          class="buy-now-btn"
          [style.background-color]="emailData.buttonColor">
          <span class="btn-text">{{ emailData.buttonText }}</span>
        </button>
      </div>
      <p class="description" [innerHTML]="sanitizeHtml(emailData.bodyText ? emailData.bodyText : 'Write the text of your email here. Describe the offers in this campaign and why it cannot be missed.')"></p>
      <p class="description" *ngIf="emailData.body2Text" [innerHTML]="sanitizeHtml(emailData.body2Text)"></p>
      <p class="description" *ngIf="emailData.body3Text" [innerHTML]="sanitizeHtml(emailData.body3Text)"></p>
      <p class="description" *ngIf="emailData.body4Text" [innerHTML]="sanitizeHtml(emailData.body4Text)"></p>
      
      <!-- Button at bottom if position is bottom -->
      <div *ngIf="emailData.buttonPosition === 'bottom'" class="button-bottom-section">
        <button 
          class="buy-now-btn"
          [style.background-color]="emailData.buttonColor">
          <span class="btn-text">{{ emailData.buttonText? emailData.buttonText : 'Add the button text here' }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer">
    <div class="footer-content">
      <div class="contact-info" [innerHTML]="getContactInfo()"></div>
      <div class="footer-links">
        <a href="#" class="footer-link">Privacy</a>
      </div>
      <div class="company-name">{{ emailData.carWashName || 'Car Wash Company' }}</div>
    </div>
  </div>
</div>